import { useState } from 'react';
import { AppLayout } from '@/components/layout/AppLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { PlanChangeHistory } from '@/components/plan/PlanChangeHistory';
import { PlanCoachChat } from '@/components/plan/PlanCoachChat';
import { SeasonView } from '@/components/calendar/views/SeasonView';
import { useSyncTodayWorkout } from '@/hooks/useSyncTodayWorkout';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { addMonths, subMonths, format, startOfMonth } from 'date-fns';

export default function TrainingPlan() {
  useSyncTodayWorkout();
  const [currentDate, setCurrentDate] = useState(new Date());
  
  const navigatePreviousQuarter = () => setCurrentDate(subMonths(currentDate, 3));
  const navigateNextQuarter = () => setCurrentDate(addMonths(currentDate, 3));
  const goToCurrentQuarter = () => setCurrentDate(new Date());

  const getQuarterLabel = () => {
    const quarterStart = startOfMonth(new Date(currentDate.getFullYear(), Math.floor(currentDate.getMonth() / 3) * 3, 1));
    const quarterEnd = new Date(quarterStart);
    quarterEnd.setMonth(quarterEnd.getMonth() + 2);
    return `${format(quarterStart, 'MMM')} – ${format(quarterEnd, 'MMM yyyy')}`;
  };

  return (
    <AppLayout>
      <div className="space-y-6">
        <PageHeader
          title="Plan"
          subtitle="Strategic training intent"
          statusLabel="STRATEGY: ACTIVE"
          actions={
            <div className="flex items-center gap-2">
              <Button variant="outline" size="icon" onClick={navigatePreviousQuarter} className="border-white/[0.08] text-slate-400 hover:text-slate-200">
                <ChevronLeft className="h-4 w-4" />
              </Button>
              <Button variant="outline" size="icon" onClick={navigateNextQuarter} className="border-white/[0.08] text-slate-400 hover:text-slate-200">
                <ChevronRight className="h-4 w-4" />
              </Button>
              <Button variant="ghost" onClick={goToCurrentQuarter} className="text-[10px] font-mono uppercase tracking-wider text-slate-400 hover:text-slate-200">
                Current
              </Button>
              <span className="font-mono text-sm text-slate-300 ml-2 whitespace-nowrap">
                {getQuarterLabel()}
              </span>
            </div>
          }
        />

        {/* Season View - Training phases, goal races, strategic overview */}
        <SeasonView currentDate={currentDate} />

        {/* Plan Change History - Strategic rationale */}
        <PlanChangeHistory />

        {/* Floating Coach Chat */}
        <PlanCoachChat />
      </div>
    </AppLayout>
  );
}
